/**
 * Single source of truth for attendance statuses
 */

export const ATTENDANCE_STATUS = {
    ABSENT: "absent",
    ATTENDED: "attended",
    CANCELLED: "cancelled",
    UNCONFIRMED: "unconfirmed",
} as const;

export type AttendanceStatus = (typeof ATTENDANCE_STATUS)[keyof typeof ATTENDANCE_STATUS];

/**
 * Actions that can be performed on attendance records
 * These map directly to statuses (excluding UNCONFIRMED)
 */
export const ATTENDANCE_ACTIONS = {
    ABSENT: ATTENDANCE_STATUS.ABSENT,
    ATTENDED: ATTENDANCE_STATUS.ATTENDED,
    CANCELLED: ATTENDANCE_STATUS.CANCELLED,
} as const;

export type AttendanceAction = (typeof ATTENDANCE_ACTIONS)[keyof typeof ATTENDANCE_ACTIONS];

/**
 * Display labels for each status
 */
export const ATTENDANCE_STATUS_LABELS: Record<AttendanceStatus, string> = {
    [ATTENDANCE_STATUS.UNCONFIRMED]: "Unconfirmed",
    [ATTENDANCE_STATUS.CANCELLED]: "Cancelled",
    [ATTENDANCE_STATUS.ATTENDED]: "Attended",
    [ATTENDANCE_STATUS.ABSENT]: "No Show",
} as const;

/**
 * Color classes for each status badge
 */
export const ATTENDANCE_STATUS_COLORS: Record<AttendanceStatus, string> = {
    [ATTENDANCE_STATUS.UNCONFIRMED]: "text-tan",
    [ATTENDANCE_STATUS.CANCELLED]: "text-charcoal/50",
    [ATTENDANCE_STATUS.ATTENDED]: "text-spruce",
    [ATTENDANCE_STATUS.ABSENT]: "text-error",
} as const;
